export default [
  {
    name: 'sport',
    type: 'autocomplete',
    value: '',
    validation: 'required',
    tableDisplay: true,
    allowEdit: true,
    icon: 'layers',
    origin: 'clubSports',
  },
  {
    name: 'type',
    type: 'select',
    value: '',
    validation: 'required',
    options: ['club', 'event'],
    tableDisplay: true,
    allowEdit: false,
    icon: 'class',
  },
  {
    name: 'club',
    type: 'text',
    value: '',
    validation: 'required',
    tableDisplay: true,
    allowEdit: true,
    icon: 'drag_handle',
  },
  {
    name: 'logo',
    type: 'image',
    value: '',
    path: '',
    temp: '',
    validation: '',
    uploading: false,
    percentage: 0,
    tableDisplay: false,
    allowEdit: true,
    icon: 'image',
  },
  {
    name: 'externalLinkText',
    type: 'text',
    value: '',
    validation: '',
    tableDisplay: false,
    allowEdit: true,
    icon: 'event_note',
  },
  {
    name: 'externalLinkUrl',
    type: 'text',
    value: '',
    validation: 'url',
    tableDisplay: false,
    allowEdit: true,
    icon: 'share',
  },
]
